import type { VesselMessage, VesselResponse } from "./types"

export function isVesselResponse<T = unknown>(
  message: VesselMessage<T>,
): message is VesselResponse<T> {
  return "originalId" in message
}
